export const initialState = {
  actionProcessing: false,
  domainRequests: [],
  agentDomains: [],
  totalCount: 0,
};

export default initialState;
